import { useQuery } from "@tanstack/react-query";

// Point this at a live feed source (a backend proxy for the Meta Graph API,
// or a third-party embed service like Behold.so / SnapWidget) once one is set up.
const FEED_URL = process.env.REACT_APP_INSTAGRAM_FEED_URL;

const PLACEHOLDER_POSTS = Array.from({ length: 8 }, (_, i) => ({
  id: `placeholder-${i + 1}`,
  mediaUrl: `/images/instagram/instaimage${i + 1}.png`,
  permalink: "https://www.instagram.com/bcg.construction/",
  caption: `Jobsite update ${i + 1}`,
}));

const fetchInstagramFeed = async () => {
  if (!FEED_URL) return PLACEHOLDER_POSTS;

  const res = await fetch(FEED_URL);
  if (!res.ok) {
    throw new Error(`Instagram feed request failed (${res.status})`);
  }
  const data = await res.json();
  return data.posts ?? data;
};

export const useInstagramFeed = () =>
  useQuery({
    queryKey: ["instagram-feed"],
    queryFn: fetchInstagramFeed,
    staleTime: 5 * 60_000,
  });
